import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>qui</td>
          <td>quae</td>
          <td>quod</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>cuius</td>
          <td>cuius</td>
          <td>cuius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>cui</td>
          <td>cui</td>
          <td>cui</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>quem</td>
          <td>quam</td>
          <td>quod</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">quo</td>
          <td className="bor-bot">qua</td>
          <td className="bor-bot">quo</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>qui</td>
          <td>quae</td>
          <td>quae</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>quorum</td>
          <td>quarum</td>
          <td>quorum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>quibus</td>
          <td>quibus</td>
          <td>quibus</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>quos</td>
          <td>quas</td>
          <td>quae</td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td>quibus</td>
          <td>quibus</td>
          <td>quibus</td>
        </tr>
      </table>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/betr-vnw.js